import { gql } from '@apollo/client';

import { SubjectFragment } from 'approot/shared/graphql/startup-data/startup-data.graphql';

export const plannerTermsFragment = gql`
  fragment PlannerTermsFragment on Planner {
    plannerTerms {
      id
      term
      plannerItemGroupsByUnits {
        isAnnotated
        unitId
        unitName
        unitSlug
        unitStatus
        unitArchivedAt
        unitNumber
        years
        subject {
          ...SubjectFragment
        }
        topic
        totalPlannerItems
        totalPlannerItemLessons
        totalPlannerItemAssessments
        completedPlannerItems
        hasRemovedItems
        plannerItemGroupId
        sort
        comingSoonMessage
        squareImage {
          id
          oneResponsive {
            xs {
              width
              height
              urls {
                url
                quality
              }
            }
          }
        }
      }
    }
  }
  ${SubjectFragment}
`;

export const completionFragment = gql`
  fragment Completion on CompletionData {
    id
    contentId
    contentType
    status
    startDate
    endDate
  }
`;

export const GET_PLANNER = gql`
  query GetPlanner($input: GetPlannerInput!) {
    getPlanner(input: $input) {
      id
      ...PlannerTermsFragment
    }
  }
  ${plannerTermsFragment}
`;

export const GET_PLANNER_OUTCOMES = gql`
  query GetPlannerOutcomes($input: GetPlannerInput!) {
    getPlanner(input: $input) {
      id
      plannerTerms {
        id
        term
        plannerItemGroupsByUnits {
          plannerItemGroupId
          outcomesByCurriculums {
            curriculum
            outcomes {
              category
              code
              version
              dciArrangements
            }
          }
        }
      }
    }
  }
`;

export const GET_PLANNER_ITEM_GROUP_BY_UNIT = gql`
  query GetPlannerItemGroupByUnit($input: GetPlannerItemsByGroupInput!) {
    getPlannerItemGroupByUnit(input: $input) {
      plannerItemGroupId
      plannerItemLessons {
        id
        lessonId
        lessonName
        lessonSubject {
          label
        }
        deleted
        isBookmarked
        isAnnotated
        archivedAt
        squareImage {
          id
          oneResponsive {
            xs {
              width
              height
              urls {
                url
                quality
              }
            }
          }
        }
      }
      plannerItemAssessments {
        id
        assessmentId
        assessmentName
        assessmentSubject {
          label
        }
        deleted
        isBookmarked
        isAnnotated
        archivedAt
        squareImage {
          id
          oneResponsive {
            xs {
              width
              height
              urls {
                url
                quality
              }
            }
          }
        }
      }
    }
  }
`;

export const DELETE_PLANNER = gql`
  mutation DeletePlanner($input: DeletePlannerInput!) {
    deletePlanner(input: $input)
  }
`;

export const ADD_PLANNER_UNIT = gql`
  mutation AddPlannerUnit($input: AddPlannerUnitInput!) {
    addPlannerUnit(input: $input) {
      id
      ...PlannerTermsFragment
    }
  }
  ${plannerTermsFragment}
`;

export const MOVE_PLANNER_UNIT = gql`
  mutation MoveUnitToTerm($input: MoveUnitToTermInput!) {
    moveUnitToTerm(input: $input) {
      id
      ...PlannerTermsFragment
    }
  }
  ${plannerTermsFragment}
`;

export const UPDATE_PLANNER_UNIT_SORT = gql`
  mutation UpdatePlannerUnitSort($input: UpdatePlannerItemGroupSortInput!) {
    updatePlannerItemGroupSort(input: $input) {
      id
      ...PlannerTermsFragment
    }
  }
  ${plannerTermsFragment}
`;

export const DELETE_PLANNER_ITEM = gql`
  mutation DeletePlannerItem($input: DeletePlannerItemInput!) {
    deletePlannerItem(input: $input) {
      id
      plannerTerms {
        plannerItemGroupsByUnits {
          plannerItemLessons {
            id
            completion {
              ...Completion
            }
          }
          plannerItemAssessments {
            id
            completion {
              ...Completion
            }
          }
        }
      }
      ...PlannerTermsFragment
    }
  }
  ${completionFragment}
  ${plannerTermsFragment}
`;

export const RESTORE_PLANNER_ITEMS = gql`
  mutation RestorePlannerItems($input: RestorePlannerItemsInput!) {
    restorePlannerItems(input: $input) {
      id
      ...PlannerTermsFragment
    }
  }
  ${plannerTermsFragment}
`;
